import {getAttributeOrThrow, qsaOptional, qsRequired} from "@/scripts/core/global";
import {UcoastEl} from "@/scripts/core/UcoastEl";
export class ContentSidebar extends UcoastEl {
    static htmlSelector = 'content-sidebar'
    sidebarContainer: HTMLElement
    contentContainer: HTMLElement
    observer?: IntersectionObserver
    headings?: HTMLHeadingElement[]
    currentActiveIndex: number = -1

    constructor() {
        super()
        this.sidebarContainer = qsRequired('[data-sidebar-container]', this)
        this.contentContainer = qsRequired('[data-content-container]', this)
        this.addAnchorAttributes()
        this.setupIntersectionObserver()
    }
    addAnchorAttributes() {
        const anchors = qsaOptional<HTMLButtonElement>('[data-scroll-trigger]', this.sidebarContainer)
        if (!anchors) return
        const sidebarAnchors = Array.from(anchors).map(anchor => {
            return getAttributeOrThrow('data-scroll-trigger', anchor)
        })
        const contentH2s = qsaOptional<HTMLHeadingElement>('h2', this.contentContainer)
        if (!contentH2s) return
        contentH2s.forEach((h2, i) => {
            if (!sidebarAnchors[i]) return
            h2.setAttribute('data-scroll-anchor', sidebarAnchors[i])
        })
        this.headings = Array.from(contentH2s)
    }
    setupIntersectionObserver() {
        const options = {
            root: null,
            rootMargin: '-20% 0px -80% 0px',
            threshold: 0
        }

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!this.headings) return
                const index = this.headings.indexOf(entry.target as HTMLHeadingElement)
                if (entry.isIntersecting) {
                    this.currentActiveIndex = index
                } else if (index === this.currentActiveIndex && !entry.isIntersecting && entry.boundingClientRect.top <= 0) {
                    this.currentActiveIndex = Math.min(index + 1, this.headings.length - 1)
                }
                this.updateActiveSidebarLink()
            })
        }, options)

        if (!this.headings) return

        this.headings.forEach(heading => {
            if (!this.observer) return
            this.observer.observe(heading)
        })
    }
    updateActiveSidebarLink() {
        if (!this.headings) return
        const activeHeading = this.headings[this.currentActiveIndex]
        if (!activeHeading) return

        const headingId = activeHeading.getAttribute('data-scroll-anchor')
        if (!headingId) return

        const sidebarLinks = qsaOptional<HTMLElement>('[data-scroll-trigger]', this.sidebarContainer)
        if (!sidebarLinks) return

        sidebarLinks.forEach(link => {
            if (link.getAttribute('data-scroll-trigger') === headingId) {
                link.classList.add('active')
            } else {
                link.classList.remove('active')
            }
        })
    }
}
